import type { ReactNode } from "react";
import { preStyle } from "./simulator-styles";

/**
 * Small pieces the simulator screens share, drawn with the admin kit's
 * tokens: a card with a titled header bar (the mock-up's section frame) and
 * a collapsed technical-details block. Notes use the kit's `Alert`.
 */

export function SimCard({
  title,
  note,
  children,
}: {
  title?: ReactNode;
  note?: ReactNode;
  children: ReactNode;
}) {
  return (
    // No `overflow: hidden`: it clipped the pickers' dropdown lists at the card's edge.
    <section className="rd-card" style={{ minWidth: 0 }}>
      {title ? (
        <div style={{ padding: "14px 20px", borderBottom: "1px solid var(--rd-line-row)" }}>
          <h2 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>{title}</h2>
          {note ? (
            <p style={{ margin: "2px 0 0", fontSize: 13, color: "var(--rd-text-secondary)" }}>{note}</p>
          ) : null}
        </div>
      ) : null}
      <div style={{ padding: "16px 20px", display: "flex", flexDirection: "column", gap: 14, minWidth: 0 }}>
        {children}
      </div>
    </section>
  );
}

/** Collapsed by default: the sanitized server data behind a result. */
export function Technical({
  summary,
  note,
  before,
  children,
}: {
  summary: ReactNode;
  note?: ReactNode;
  before?: ReactNode;
  children: ReactNode;
}) {
  return (
    <details style={{ fontSize: 13 }}>
      <summary style={{ cursor: "pointer", color: "var(--rd-text-secondary)" }}>{summary}</summary>
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
        {note ? <p style={{ margin: 0 }}>{note}</p> : null}
        {before ?? null}
        <pre dir="ltr" style={preStyle}>
          {children}
        </pre>
      </div>
    </details>
  );
}
